export const UNRANKED = 0;

export const DEFAULT_PRECISE_TEMPLATE =
  "You've indicated that improving %criterion1% from %worst1% %unit1% to %best1% %unit1% is the most important (i.e. it has 100% importance). Now indicate the relative importance (in %) to this improvement of each other criterion's improvement using the sliders below.";

export const DEFAULT_MATCHING_TEMPLATE =
  'How much better should %criterion1% minimally become to justify the worsening of %criterion2%?';

export const DEFAULT_IDENTIFICATION_QUESTION =
  'Please enter your name or an indentifier for your response for this survey:';

export const DEFAULT_INTRODUCTION = 'Please fill in this survey.';

export const DEFAULT_FINISH_SURVEY_MESSAGE =
  'Thank you for taking this survey! Your response has been recorded. You can now safely close the window.';
